module.exports = __webpack_public_path__ + "img/expoglitter_9302_fushia.656f052b.jpg";